module.exports = __webpack_public_path__ + "static/img/ai-head-tag.df0b436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/ai-head-tag.png
// module id = 8oxX
// module chunks = 2